// Packages
import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
// Services
import userService from "../../services/user.service";
// Styles
import "./superAdmin.css";
// Assets
import Moment from "moment";
import { Paper } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";

import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

class WebsiteDetails extends Component {
  constructor(props) {
    super();
    this.myref = React.createRef();
    this.state = {
      newsLetterPageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      newsLetterNotFound: false,
      newsLetterSearchQuery: "",
      loginRole: getFromLocalStorage("loginRole"),
    };
  }

  componentDidMount() {
    const acticve = document.getElementById("Website");
    if (acticve) {
      acticve.classList.add("active");
    }
    this.getAllNewsLetterByPage(
      this.state.newsLetterPageState.page,
      this.state.newsLetterPageState.pageSize
    );
  }

  getAllNewsLetterByPage = (page, size) => {
    const { newsLetterNotFound } = this.state;
    this.setState({
      newsLetterPageState: {
        ...this.state.newsLetterPageState,
        isLoading: true,
      },
    });
    userService
      .getAllNewsLetters(page, size)
      .then((res) => {
        this.setState({
          newsLetterPageState: {
            ...this.state.newsLetterPageState,
            data: res.data.data[0].newsLettersList,
            isLoading: false,
            total: res.data.data[0].total,
            page: page,
          },
        });
        if (newsLetterNotFound) {
          this.setNewsLetterNotFound();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  setNewsLetterNotFound = () => {
    this.setState({ newsLetterNotFound: false });
  };

  render() {
    const {
      newsLetterPageState,
      loginRole,
    } = this.state;

    const tableColumns2 = [
      {
        field: "createdAt",
        headerName: "Enquiry Date",
        headerAlign: "center",
        align: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          return <div>{Moment(params.row.createdAt).format("MM/DD/YYYY")}</div>;
        },
      },
      {
        field: "email",
        headerName: "Email",
        headerAlign: "center",
        align: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          return (
            <div className="d-flex-align-cent height-70 w-100">
              <p className="text-width-auto mg-auto">{params.row.email}</p>
            </div>
          );
        },
      },
    ];

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div id="superAdmin-table">
            <SuperAdminDashboard />
            <div className="content-layout pt-20">
            <div className="mng-header stickyy">
                <h4 className="fs-24 bold mob-hd">NEWSLETTER</h4>
              </div>
              <div className="panel-content conclass-website-table plr">
                <Paper>
                  <DataGrid
                    rows={newsLetterPageState.data}
                    rowCount={newsLetterPageState.total}
                    loading={newsLetterPageState.isLoading}
                    pagination
                    page={newsLetterPageState.page}
                    columns={tableColumns2}
                    pageSize={newsLetterPageState.pageSize}
                    rowsPerPageOptions={[10]}
                    paginationMode="server"
                    onPageChange={(newPage) => {
                      this.getAllNewsLetterByPage(newPage, 10);
                      this.setState({
                        newsLetterPageState: {
                          ...newsLetterPageState,
                          page: newPage,
                        },
                      });
                    }}
                    onPageSizeChange={(newPageSize) =>
                      this.setState({
                        newsLetterPageState: {
                          ...newsLetterPageState,
                          pageSize: newPageSize,
                        },
                      })
                    }
                    sx={{
                      color: "black",
                      fontFamily: "Rajdhani-SemiBold",
                      fontSize: "18px",
                      backgroundColor: "white",
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                    }}
                    autoHeight
                    disableColumnMenu
                    getRowHeight={() => "auto"}
                    disableSelectionOnClick
                  />
                </Paper>
              </div>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default WebsiteDetails;